<template>
  <div class="container">
      <LoadingSpinner :loading="loading"> </LoadingSpinner>

      <div class="mt-4" style="max-width:545px">
            <h3>Z-rapport (Dagsoppgjør)</h3>
            <div v-if="!loading">
                  <div v-if="hasMultiLocations()" class="mt-5">
                    <span class="ingredient-title">Velg avdeling</span>
                    <select class="form-select" v-model="locationId" @change="showTerminals()">
                      <option v-for="(location, index) in locations" :key="index" :value="location.id">{{ location.name }}</option>
                    </select>
                  </div>

                  <div v-if="terminals.length > 0">
                      <SelectTerminal :terminals="terminals" :terminal="selectedTerminal" @setSelectedTerminal="setSelectedTerminal"/>
                      <div class="btn-group mt-3 mb-3 w-100" role="group">
                        <button type="button" class="btn toggle-btn" :class="{ active: !exportMode }" @click="setExportMode(false)">Vis Z-rapport</button>
                        <button type="button" class="btn toggle-btn" :class="{ active: exportMode }" @click="setExportMode(true)">Eksporter periode som PDF</button>
                      </div>

                      <div v-if="!exportMode">
                        <SelectDate ref="selectDate" :label="'Velg dato'" :selectedDate="selectedDateString"/>
                        <button type="button" class="bo_btn" :class="zReportsList.length === 0 ? 'mb-5' : 'mb-0'"
                                @click="showZReport"> Vis Z-rapport </button>

                        <div v-if="zReportsList.length === 0 && resultFetched" class="xz-report mb-5">
                          <p class="no-report-found">Fant ingen Z-rapport.</p>
                        </div>

                        <div v-if="zReportsList.length > 1" class="alert alert-warning mt-3">
                          Advarsel: Det finnes {{ zReportsList.length }} Z-rapporter for valgt dato.
                        </div>

                        <ShowZReport v-for="(zr, index) in zReportsList" :key="index"
                                     :location="getLocation"
                                     :terminal="selectedTerminal"
                                     :zReport="zr"
                                     :company="company"
                                     :vat="vat"
                                     :showValidate="isSuperAdmin()"
                                     @validate="validateZReports" />
                      </div>

                      <div v-if="exportMode">
                        <SelectDate ref="fromDate" :label="'Velg fra og med dato'" :selectedDate="fromDateString"/>
                        <SelectDate ref="toDate" :label="'Velg til og med dato'" :selectedDate="toDateString"/>
                        <button type="button" class="bo_btn mb-3" @click="exportPeriodPdf" :disabled="generatingPdf">
                          {{ generatingPdf ? 'Genererer PDF...' : 'Last ned PDF' }}
                        </button>

                        <div v-if="zReports.length === 0 && resultFetched" class="xz-report mb-5">
                          <p class="no-report-found">Fant ingen Z-rapporter for valgt periode.</p>
                        </div>

                        <div v-if="zReports.length > 0" class="mb-5">
                          <p class="mt-2 mb-3">Fant {{ zReports.length }} Z-rapport(er). PDF lastes ned.</p>
                        </div>
                      </div>
                  </div>
                  <div v-else class="mt-4 mb-5">
                    <p>
                      Ingen kassepunkt er satt opp for denne avdelingen.
                    </p>
                  </div>
          </div>
      </div>
  </div>
  <ValidationResultModal ref="validationModal" />
</template>

<script>
  import LoadingSpinner from "@/components/other/LoadingSpinner";
  import SelectTerminal from "@/components/report/SelectTerminal";
  import SelectDate from "@/components/other/SelectDate";
  import ShowZReport from "@/components/report/zreport/ShowZReport";
  import ReportService from "@/services/report/ReportService";
  import ReportPdfBuilder from "@/util/ReportPdfBuilder";
  import LocationUtil from "@/util/LocationUtil";
  import TerminalService from "@/services/terminal/TerminalService";
  import TerminalVisibility from "@/util/TerminalVisibility";
  import MerchantUtil from "@/util/MerchantUtil";
  import UserUtil from "@/util/UserUtil";
  import ReportValidator from "@/util/ReportValidator";
  import ValidationResultModal from "@/components/report/ValidationResultModal";
  import moment from "moment";

  export default {
    components: {LoadingSpinner, SelectTerminal, SelectDate, ShowZReport, ValidationResultModal},
    data() {
      return {
        loading: true,

        locationId: '',
        locations: [],
        merchant: '',
        company: {},
        terminals: [],
        selectedTerminal: {},
        selectedDate: new Date(),
        selectedDateString: moment().format('YYYY-MM-DD'),
        vat: {},
        zReport: {},
        zReportsList: [],
        resultFetched: false,
        exportMode: false,
        fromDateString: moment().format('YYYY-MM-DD'),
        toDateString: moment().format('YYYY-MM-DD'),
        zReports: [],
        generatingPdf: false
      };
    },
    computed: {
      getLocation(){
        return LocationUtil.getLocation(this.locationId);
      },
      isXReportCountersEmpty() {
        if(this.xReportCounters.vippsPickupVat == 0 &&
            this.xReportCounters.vippsDeliveryVat == 0 &&
            this.xReportCounters.vippsDeliveryServiceVat == 0 &&
            this.xReportCounters.vippsPickupBrutto == 0 &&
            this.xReportCounters.vippsDeliveryBrutto == 0 &&
            this.xReportCounters.vippsDeliveryServiceBrutto == 0 &&
            this.xReportCounters.cardPickupVat == 0 &&
            this.xReportCounters.cardDeliveryVat == 0 &&
            this.xReportCounters.cardDeliveryServiceVat == 0 &&
            this.xReportCounters.cardPickupBrutto == 0 &&
            this.xReportCounters.cardDeliveryBrutto == 0 &&
            this.xReportCounters.cardDeliveryServiceBrutto == 0 &&
            this.xReportCounters.refundReceiptsCount == 0 &&
            this.xReportCounters.refundReceiptsTotalAmount == 0){
          return true;
        } else {
          return false;
        }
      }
    },
    mounted() {
      ReportService.getDataForReportGui().then(
          (response) => {
            let dataForGui = response.data;
            //console.log("dataForGui: " +  JSON.stringify(dataForGui));
            this.locations = dataForGui.locations;
            this.company = dataForGui.company;
            this.vat = dataForGui.vat;
            this.merchant = dataForGui.merchant;

            this.locationId = this.locations.length ? this.locations[0].id : '';
            this.loading = false;
            this.showTerminals();
          },
          (error) => {
            console.log(error);
          }
      );
    },
    methods: {
      isSuperAdmin(){
        return UserUtil.isSuperAdmin();
      },
      hasMultiLocations(){
        return LocationUtil.hasMultiLocations();
      },
      showTerminals() {
        this.loading = true;
        this.zReport= {}; //reset it
        this.zReportsList = [];

        this.resultFetched = false;
        console.log('showTerminals for locationId: ' + this.locationId);

        TerminalService.getTerminalsForLocation(this.locationId).then(
            (response) => {
              let filteredTerminals = [];
              // A terminal SUPER_ADMIN hid from the merchant (a test till) is left out for everyone else.
              const visibleTerminals = TerminalVisibility.forMerchantView(response.data);
              for(let i = 0; i < visibleTerminals.length; i++) {
                let terminal = visibleTerminals[i];
                if(terminal.terminalType != 'KDS'){
                  filteredTerminals.push(terminal);
                }
              }

              if(this.useFunctionality() === 'TAKEAWAY' || this.useFunctionality() === 'KIOSK_TAKEAWAY' || this.useFunctionality() === 'ALL'){
                let webshop = {
                  terminalId: 'WEBSHOP',
                  locationId: this.locationId
                };
                filteredTerminals.push(webshop);
              }

              this.terminals = filteredTerminals;
              this.selectedTerminal = this.terminals.length > 0 ? this.terminals[0] : {};

              this.loading = false;
            },
            (error) => {
              console.log(error);
            }
        );
      },
      setSelectedTerminal(terminal){
        this.selectedTerminal = terminal;
        this.zReport= {}; //reset it
        this.zReportsList = [];

        this.resultFetched = false;
       },
      useFunctionality(){
        return MerchantUtil.useFunctionality();
      },
      showZReport() {
        this.loading = true;

        this.selectedDateString = this.$refs.selectDate.getSelectedDate();
        this.selectedDate = moment(this.selectedDateString, 'YYYY-MM-DD').toDate();
        console.log('Vis Z-report for locationId: ' + this.selectedTerminal.locationId + ', terminalId: ' + this.selectedTerminal.terminalId +  ', selectedDate: ' + this.selectedDateString);
        ReportService.getZReport(this.selectedTerminal.locationId, this.selectedTerminal.terminalId, this.selectedDateString).then(
            (response) => {
              if(Array.isArray(response.data)) {
                this.zReportsList = response.data.map(item => item.cagistahospitality).filter(item => item);
                this.zReport = this.zReportsList.length > 0 ? this.zReportsList[0] : {};
              } else if(response.data && response.data.cagistahospitality) {
                this.zReportsList = [response.data.cagistahospitality];
                this.zReport = response.data.cagistahospitality;
              } else {
                this.zReportsList = [];
                this.zReport = {};
              }
              this.loading = false;
              this.resultFetched = true;
            },
            (error) => {
              console.log(error);
            }
        );
      },
      validateZReports(){
        let allResults = [];
        for (let i = 0; i < this.zReportsList.length; i++) {
          const prefix = this.zReportsList.length > 1 ? ('Nr.' + this.zReportsList[i].nr + ': ') : '';
          const results = ReportValidator.validateZReport(this.zReportsList[i], this.vat);
          results.forEach(r => { r.label = prefix + r.label; });
          allResults = allResults.concat(results);
        }
        this.$refs.validationModal.open(allResults);
      },
      isObjectEmpty(jsonObject){
        return JSON.stringify(jsonObject) === '{}';
      },
      setExportMode(mode) {
        if (this.exportMode === mode) return;
        this.exportMode = mode;
        this.zReport = {};
        this.zReportsList = [];
        this.zReports = [];
        this.resultFetched = false;
      },
      async exportPeriodPdf() {
        this.generatingPdf = true;
        this.zReports = [];
        this.resultFetched = false;

        const fromDate = this.$refs.fromDate.getSelectedDate();
        const toDate = this.$refs.toDate.getSelectedDate();

        try {
          const response = await ReportService.getTotalSalesReport(
              this.selectedTerminal.locationId,
              this.selectedTerminal.terminalId,
              fromDate,
              toDate
          );

          const reports = response.data;
          if (reports && reports.length > 0) {
            this.zReports = reports;
            this.resultFetched = true;

            ReportPdfBuilder.buildMultiZReportPdf(
                reports,
                this.getLocation,
                this.selectedTerminal,
                this.vat,
                'Z-rapporter_' + moment(fromDate).format('DD_MM_YYYY') + '-' + moment(toDate).format('DD_MM_YYYY') + '.pdf'
            );
          } else {
            this.zReports = [];
            this.resultFetched = true;
          }
        } catch (error) {
          console.log(error);
        }

        this.generatingPdf = false;
      },
    }
  };
</script>

<style scoped>
  .toggle-btn {
    background-color: var(--bo-surface);
    color: var(--bo-ink);
    border: 1px solid var(--bo-muted-2);
    transition: all 0.2s ease;
  }
  .toggle-btn.active {
    background-color: var(--bo-ink);
    color: var(--bo-surface);
    border-color: var(--bo-ink);
  }
</style>
